import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import { clearSelection, getIsQuerySelected, selectQuery } from '../redux/selectionSlice';
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import Small from 'UIComponents/elements/Small';
import { TABLE_ROW_HEIGHT } from '../../table/constants/sizes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TABLE_BORDER_COLOR } from 'HubStyleTokens/theme';
import { CELL_BORDER_WIDTH } from '../../table/constants/sizes';
const Row = styled.tr.withConfig({
  displayName: "SelectQueryRow__Row",
  componentId: "xrg8yd-0"
})(["background-color:", ";height:", "px;box-shadow:inset 0 -", "px ", ";"], CALYPSO_LIGHT, TABLE_ROW_HEIGHT, CELL_BORDER_WIDTH, TABLE_BORDER_COLOR);
const Cell = styled.td.withConfig({
  displayName: "SelectQueryRow__Cell",
  componentId: "xrg8yd-1"
})(["border:0 !important;"]);
const PaddedSmall = styled(Small).withConfig({
  displayName: "SelectQueryRow__PaddedSmall",
  componentId: "xrg8yd-2"
})(["padding-left:200px;"]);

const SelectQueryRow = ({
  rowIds,
  columnCount,
  totalRowCount,
  CustomSelectAllComponent
}) => {
  const dispatch = useTableDispatch();
  const isQuerySelected = useTableSelector(getIsQuerySelected);
  const selectEverything = useCallback(() => dispatch(selectQuery()), [dispatch]);
  const clearAllSelections = useCallback(() => dispatch(clearSelection()), [dispatch]);
  return /*#__PURE__*/_jsx(Row, {
    "data-test-id": "select-query-row",
    children: /*#__PURE__*/_jsx(Cell, {
      colSpan: columnCount,
      children: /*#__PURE__*/_jsx(PaddedSmall, {
        children: isQuerySelected ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            useGap: true,
            message: "datatable.bulkActions.querySelected",
            options: {
              count: totalRowCount
            }
          }), /*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "clear-selection-button",
            use: "link",
            onClick: clearAllSelections,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "datatable.bulkActions.clearSelection"
            })
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            useGap: true,
            message: "datatable.bulkActions.pageSelected",
            options: {
              count: rowIds.length
            }
          }), /*#__PURE__*/_jsx(CustomSelectAllComponent, {
            selectEverything: selectEverything,
            totalRowCount: totalRowCount
          })]
        })
      })
    })
  });
};

export default SelectQueryRow;